<template>
    <div>
        <div class="top-box">
            <div class="search-box">
                <el-input v-model="keywords" placeholder="请输入查询留言者" size="small"></el-input>
                <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
            </div>
        </div>
        <div class="table-box">
            <el-table :data="tableData" border style="width: 100%" >
                <el-table-column type="index" label="序号" width="100" align="center" :index="indexMethod">
                </el-table-column>
                <el-table-column prop="name" label="留言者" align="center" width="150" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="content" label="留言内容" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="email" label="邮箱" align="center" width="200" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="time" label="日期" align="center" width="200" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.status == 0">未回复</el-tag>
                        <el-tag type="success" v-if="scope.row.status == 1">已回复</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button :type="scope.row.status == 0 ?'success':'primary'" size="small" @click="onReply(scope.row)">{{ scope.row.status == 0 ?'回复':'编辑' }}</el-button>
                        <el-button type="danger" size="small" @click="deleteMessage(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-box">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                @current-change="handleCurrentChange" @prev-click="prevCilck" @next-click="nextCilck"
                :current-page.sync="page">
            </el-pagination>
        </div>
        <div v-if="DialogVisible">
            <el-dialog :title="DialogTitle" :visible.sync="DialogVisible" width="35%" :destroy-on-close="true">
                <ReplyMessage v-on:onDialog="upDialogStatus" v-bind:editID="editID"></ReplyMessage>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import ReplyMessage from "./replyMessage.vue";
export default {
    components: {
        ReplyMessage,
    },
    data() {
        return {
            keywords: '',
            tableData: [],
            DialogVisible: false,
            DialogTitle: '',
            editID: 0,
            total: 0,
            page: 1,
            pageSize: 10,
        }
    },
    methods: {
        async getMessageList(){
            const { data: res } = await this.$axios.post('/message', {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        async deleteMessage(e){
            console.log(e);
            const { data: res } = await this.$axios.post("/message/delMessage", e);
            console.log(res);
            if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
            this.getMessageList();
            return this.$message.success(res.meta.msg);
        },
        onReply(e) {
            this.DialogVisible = true;
            this.DialogTitle = "编辑留言";
            this.editID = e.id;
            console.log(e);
        },
        async onSearch() {
            this.page = 1;
            const { data: res } = await this.$axios.post("/message", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            console.log(res);
            this.tableData = res.data.list;
            this.total = res.data.total;
        },
        async handleCurrentChange(page) {
            this.page = page;
            const { data: res } = await this.$axios.post("/message", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        async prevCilck(page) {
            console.log(page);
            this.page = page;
            const { data: res } = await this.$axios.post("/message", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        async nextCilck(page) {
            console.log(page);
            this.page = page;
            const { data: res } = await this.$axios.post("/message", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        upDialogStatus(e) {
            this.DialogVisible = e;
            this.getMessageList();
        },
        indexMethod(index) {
            if (this.total < this.pageSize) {
                return this.total - index;
            } else {
                return (this.total - ((this.page - 1) * this.pageSize) - index);
            }
        },
    },
    created(){
        this.getMessageList();
    }
}
</script>

<style lang="less">
.top-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .search-box {
        display: flex;
        align-items: center;

        .el-input {
            min-width: 350px;
            margin-right: 10px;
        }
    }
}

.table-box {
    margin-top: 20px;
}

.page-box {
    margin-top: 10px;
    float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/message/message.vue